import { render, staticRenderFns } from "./button-primary.vue?vue&type=template&id=4e5a590c&scoped=true"
import script from "./button-primary.vue?vue&type=script&lang=js"
export * from "./button-primary.vue?vue&type=script&lang=js"
import style0 from "./button-primary.vue?vue&type=style&index=0&id=4e5a590c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a590c",
  null
  
)

export default component.exports